import Image from 'next/image';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import CropDoctorImage from '@/images/posts/get-help.webp';
import CaretDownIcon from './icons/CaretDownIcon';
import SubHeading from './SubHeading';
const CropDoctorHelp = () => {
  const {
    t
  } = useTranslation('posts');
  return <Link href="/ask-help" className="flex items-center gap-3 px-4 py-3 text-white rounded-lg bg-blue-green-100" data-sentry-element="Link" data-sentry-component="CropDoctorHelp" data-sentry-source-file="CropDoctorHelp.tsx">
      <Image alt={t('crop_doctor_help')} className="w-12 h-12" src={CropDoctorImage} data-sentry-element="Image" data-sentry-source-file="CropDoctorHelp.tsx" />
      <SubHeading className="text-left grow" data-sentry-element="SubHeading" data-sentry-source-file="CropDoctorHelp.tsx">
        {t('crop_doctor_help')}
      </SubHeading>
      <CaretDownIcon className="h-4 ml-2 -rotate-90 stroke-2 fill-transparent stroke-white" data-sentry-element="CaretDownIcon" data-sentry-source-file="CropDoctorHelp.tsx" />
    </Link>;
};
export default CropDoctorHelp;